declare global {
  interface Navigator {
    globalPrivacyControl?: boolean;
  }
}

export function detectGPC(): boolean {
  return globalThis.navigator?.globalPrivacyControl === true;
}

/**
 * Detect a Do Not Track signal. `navigator.doNotTrack` is "1" (or "yes" on
 * some older browsers) when the user has enabled DNT; a few browsers expose it
 * on `window` instead. Like GPC, we treat DNT as a request to disable
 * non-essential cookies.
 */
export function detectDNT(): boolean {
  const nav = globalThis.navigator as (Navigator & { doNotTrack?: string | null }) | undefined;
  const raw = nav?.doNotTrack ?? (globalThis as { doNotTrack?: string | null }).doNotTrack ?? null;
  return raw === '1' || raw === 'yes';
}

/** True when the browser signals a privacy preference (GPC or DNT). */
export function detectPrivacySignal(): boolean {
  return detectGPC() || detectDNT();
}
